import { IconProps } from "../../utils/global-types/global-types";

const OpenFolderIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      className={className ? className : "w-[40px] h-[40px]"}
      {...rest}
    >
      <path
        d="M38.2183 15.7889C38.0184 15.4281 37.7253 15.1275 37.3696 14.9186C37.0138 14.7098 36.6085 14.6003 36.196 14.6016H14.2709C13.5316 14.6015 12.8124 14.8413 12.221 15.2848C11.6296 15.7283 11.198 16.3517 10.9911 17.0613L6.65135 31.9404C6.42288 32.7237 5.94653 33.4117 5.29379 33.9012C4.64106 34.3908 3.84716 34.6554 3.03125 34.6554H30.6035C31.4196 34.6554 32.2137 34.3907 32.8665 33.901C33.5194 33.4114 33.9958 32.7232 34.2243 31.9398L38.3904 17.6566C38.4873 17.3495 38.522 17.0261 38.4925 16.7054C38.4629 16.3847 38.3697 16.0732 38.2183 15.7889Z"
        fill="currentColor"
      />
      <path
        d="M5.17129 31.5082L9.5137 16.6298C9.81622 15.6012 10.4429 14.6979 11.3005 14.0544C12.158 13.4109 13.2005 13.0617 14.2726 13.0587H33.8868V12.2874C33.8868 11.4692 33.5617 10.6844 32.9831 10.1058C32.4046 9.52725 31.6198 9.2022 30.8016 9.2022H19.0436C18.8138 9.2022 18.5868 9.15097 18.3793 9.05224C18.1717 8.95351 17.9888 8.80976 17.8437 8.63144L16.3276 6.76713C15.9664 6.32306 15.5108 5.96506 14.9939 5.71918C14.477 5.4733 13.9118 5.34571 13.3393 5.3457H4.57739C3.75914 5.3457 2.97441 5.67075 2.39582 6.24934C1.81723 6.82792 1.49219 7.61266 1.49219 8.4309L1.49219 31.5699C1.49219 31.979 1.65471 32.3714 1.944 32.6607C2.2333 32.95 2.62566 33.1125 3.03479 33.1125C3.51627 33.1112 3.98444 32.9543 4.36946 32.6651C4.75448 32.376 5.03574 31.9702 5.17129 31.5082Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OpenFolderIcon;
